import { show } from '@intercom/messenger-js-sdk';
import { Button, type ButtonProps } from '@plato/ui-legacy/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@plato/ui/primitives/tooltip';
import { cn } from '@plato/ui/util/classes';
import { CircleHelpIcon } from 'lucide-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export type IntercomLauncherProps = {
    expanded?: boolean;
    className?: string;
    variant?: ButtonProps['variant'];
};

const IntercomLauncher = React.forwardRef<HTMLButtonElement, IntercomLauncherProps>(
    ({ expanded = true, className = '', variant = 'ghost' }, ref) => {
        const { t } = useTranslation('common');

        if (expanded) {
            return (
                <Button
                    ref={ref}
                    className={cn('w-full justify-start text-neutral-950', className)}
                    variant={variant}
                    onClick={() => {
                        show();
                    }}
                    leftIcon={CircleHelpIcon}
                >
                    <span className="font-normal">{t('support__button')}</span>
                </Button>
            );
        }

        return (
            <Tooltip>
                <TooltipTrigger
                    render={
                        <Button
                            ref={ref}
                            variant={variant}
                            size="icon-s"
                            onClick={() => {
                                show();
                            }}
                            icon={CircleHelpIcon}
                        />
                    }
                />
                <TooltipContent side="right">{t('support__button')}</TooltipContent>
            </Tooltip>
        );
    },
);
IntercomLauncher.displayName = 'IntercomLauncher';

export { IntercomLauncher };
